import { IllustrationFrame, CroppedPhone, type IllustrationProps } from './illustration-parts';
import { InboxList } from './connection-parts';

export function Inbox({ transparent = false }: IllustrationProps) {
  return (
    <IllustrationFrame transparent={transparent}>
      {(s) => (
        <CroppedPhone s={s} width={116} y={10}>
          <InboxList s={s} width={92} />
        </CroppedPhone>
      )}
    </IllustrationFrame>
  );
}
